import {ContainerBinder} from '../../../../../IoC/ContainerBinder';
import {CreateDiaryEntryCmd} from '../../ports/CreateDiaryEntry/CreateDiaryEntry.cmd';
import {CreateDiaryEntryCmdJrpc} from '../../ports/CreateDiaryEntry/jrpc/CreateDiaryEntry.cmd.jrpc';
import {DeleteDiaryEntryCmd} from '../../ports/DeleteDiaryEntry/DeleteDiaryEntry.cmd';
import {DeleteDiaryEntryCmdJrpc} from '../../ports/DeleteDiaryEntry/jrpc/DeleteDiaryEntry.cmd.jrpc';
import {FetchMetricsQuery} from '../../ports/FetchMetrics/FetchMetrics.query';
import {FetchMetricsQueryJrpc} from '../../ports/FetchMetrics/jrpc/FetchMetrics.query.jrpc';
import {ListDiaryEntriesQueryJrpc} from '../../ports/ListDiaryEntries/jrpc/ListDiaryEntries.query.jrpc';
import {ListDiaryEntriesQuery} from '../../ports/ListDiaryEntries/ListDiaryEntries.query';
import {TrackWeightCmdJrpc} from '../../ports/TrackWeight/jrpc/TrackWeight.cmd.jrpc';
import {TrackWeightCmd} from '../../ports/TrackWeight/TrackWeight.cmd';

export const trackersBindPortsJrpc = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container)
    .bindSingleton(FetchMetricsQuery, FetchMetricsQueryJrpc)
    .bindSingleton(TrackWeightCmd, TrackWeightCmdJrpc)
    .bindSingleton(CreateDiaryEntryCmd, CreateDiaryEntryCmdJrpc)
    .bindSingleton(ListDiaryEntriesQuery, ListDiaryEntriesQueryJrpc)
    .bindSingleton(DeleteDiaryEntryCmd, DeleteDiaryEntryCmdJrpc)
    .done();
};
